import { CREATE_COUPONCODE_PROMOTION, GET_COUPONCODE_PROMOTIONS, GET_COUPONCODE_PROMOTION, SET_ALL_COUPONCODE_PROMOTIONS, UPDATE_COUPONCODE_PROMOTION } from "../../../reducerTypes";
  
  const initialState = {
    getData: {},
    getList: [],
  };
  
  const couponCodePromotionReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_ALL_COUPONCODE_PROMOTIONS:
        return {
          ...state,
          getList: action.payload,
        };
      case GET_COUPONCODE_PROMOTIONS:
        return {
          ...state,
          getList: action.payload,
        };
      case CREATE_COUPONCODE_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      case GET_COUPONCODE_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      case UPDATE_COUPONCODE_PROMOTION:
        return {
          ...state,
          getData: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default couponCodePromotionReducer;
  